import React from 'react';
import styled from 'styled-components';

const shouldForwardProp = prop => !['progress'].includes(prop);

const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 4px;
  background-color: var(--GrayScale-400);
  border-radius: 2px;
  margin-top: 8px;
`;

const Progress = styled.div.withConfig({ shouldForwardProp })`
  width: ${props => props.progress}%;
  height: 100%;
  background-color: var(--Primary-400);
  border-radius: 2px;
  transition: width 0.3s ease-in-out;
`;

const ProgressBar = ({ progress = 0 }) => {
  return (
    <ProgressBarWrapper>
      <Progress progress={progress} />
    </ProgressBarWrapper>
  );
};

export default ProgressBar;
